var canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  )
  if(canUseDOM ){
    console.log('########canUseDOM########');
  }
  else {
    console.log('########canNotUseDOM########');
  }
  export const Dummy = () => {
    console.log('Dummy Loaded')
  }